import * as yup from "yup";
import { sitePhrasing } from "../../../Language/languageHandler";
import { GenerateStateAnnualValidation, StateAnnualValidation } from "./AnnualReportStateForms/StateSpecificAnnualReportFields";
import { StateAnnualPastDueValidation } from "./PastDueAnnualReport/StateSpecificPastDueAnnualReportFields";
import { einTaxIdValidationSchema, fictNameRenewalValidationSchema, legalNameValidationSchema } from "./productSpecificValidation";

export const generatePurchaseFormInitialValues = (
  selectedProducts: any,
  options: any = {}
) => {
  const {
    annualBusinessType = "", // Mississippi and Virginia Only
  } = options;
  return {
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    referenceNumber: "",
    businessName: selectedProducts["legalNoticeAdvertisement"] ? "-" : "",
    iAgree: false,
    generalAgree: false,
    termAndConditionAgree: false,
    electronicSignature: '',

    promoCode: '',

    generalAddress: {
      address: "",
      address2: "",
      city: "",
      state: "",
      zip: "",
    },

    boiReport: {
      typeOfFiling: "",

      legaBusinessName: "",
      taxIdType: "",
      taxIdNumber: "",
      taxIdCountry: "",
      // make it todays date yyyy-mm-dd
      datePrepared: new Date().toISOString().split("T")[0],

      // PART 1
      reportingCompany: {
        requestFinCenId: false,
        foreignPooledInvestment: false,
        legalName: "",
        alternateNames: [],

        taxIdType: "",
        taxIdNumber: "",
        taxIdCountry: "",

        countryJurisdictionOfFormation: "",

        address: "",
        address2: "",
        city: "",
        state: "",
        zip: "",
        country: "",

        existingReportingCompany: false,
      },
      companyApplicants: []


    },

    fictitiousNameRenewal: {
      tradeNameDBA: "",
      isThisYourInformation: "",
      informationStillAccurate: "",

      updateAddEin: "",
      feiEin: "",

      updateCurrentAddress: "",
      updatedCurrentAddress: {
        address: "",
        address2: "",
        city: "",
        state: "",
        zip: "",
        county: "",
      },

      changeOwner: "",

      deletingOwners: "",
      deletedOwners: [],

      addingOwners: "",
      addedOwners: [],

      changingOwnerAddresses: "",
      changedOwnerAddresses: [],


      // deleteCurrentOwner: "",
      // changeOwnerAddress: "",
      // changedOwnerAddress: {
      //   address: "",
      //   address2: "",
      //   city: "",
      //   state: "",
      //   zip: "",
      // },
      // newOwners: [],

      sunbizPayload: {},

      fictitiousNameAgreement: false,
      tellingTruth: false,
      iAmAuthorized: false,
      digitalSignature: "",
    },
    einTaxInfo: {
      legalStructure: "", //sitePhrasing.state === 'Florida' ? 'LLC' : '',
      partnershipType: "",
      membersInLLC: "",
      llcMembersHusbandWife: "",
      llcClassification: "",
      whyRequesting: "",
      responsibleParty: {
        firstName: "",
        middleName: "",
        lastName: "",
        suffix: "",
        ssnItin: "",
        ssnOrItin: "",
      },
      physicalLocation: {
        address: "",
        address2: "",
        city: "",
        state: "",
        zip: "",
      },
      differentAddressInfo: {
        differentAddress: "",
        address: "",
        address2: "",
        city: "",
        state: "",
        zip: "",
      },
      about: {
        legalName: "",
        tradeNameDBA: "",
        county: "",
        stateArticlesFiled: "",
        fileDate: "",
        closingMonthAccountingPeriod: "",
        highwayVehicle: "",
        gamblingOrWagering: "",
        form720: "",
        alcoholTobaccoFirearms: "",
        w2Info: {
          expectW2: "",
          firstDateWages: "",
          highestAgricultureEmployeeCount: "",
          highestEmployeeCount: "",
          taxLiableLessThan1k: "",
        },
      },
      primaryBusinessActivity: "",
      primaryBusinessActivityPreDescription: "", // validate
      primaryBusinessActivityDescription: "", // validate
      primaryBusinessActivitySpecifyType: "", // Validate
      primaryBusinessActivitySpecify: "",
      einAgreement: false,
      digitalSignature: "",
    },
    annualReport: {
      // Florida Only Fields
      sunbizPayload: {},
      isThisYourInformation: "",
      informationStillAccurate: "",

      // Florida & Indiana & Mississippi Only Fields
      feiEin: "",
      feiEinStatus: "",

      // Mississippi Only Fields
      useSSN: sitePhrasing.state === "Mississippi" && annualBusinessType === 'corporation' ? "EIN" : "",
      // useSSN: "",
      // useSSN: false,
      hasWrittenOperatingAgreement: false,
      nonProfitMembers: "",
      isNonProfit501c3: "",
      nonProfitSolicitDonations: "",
      nonProfitPublicFunds: "",
      purposeOfNonProfit: "",
      signerAddress: {
        address: "",
        address2: "",
        city: "",
        state: "",
        zip: "",
      },

      // Georgia Only Fields
      // typeOfEntity: annualBusinessType ? annualBusinessType : "",
      entityCEO: "",
      entityCEOAddress: {
        address: "",
        address2: "",
        city: "",
        state: "",
        zip: "",
      },
      entityCFO: "",
      entityCFOAddress: {
        address: "",
        address2: "",
        city: "",
        state: "",
        zip: "",
      },
      entitySecretary: "",
      entitySecretaryAddress: {
        address: "",
        address2: "",
        city: "",
        state: "",
        zip: "",
      },
      entityPresident: "",
      entityPresidentAddress: {
        address: "",
        address2: "",
        city: "",
        state: "",
        zip: "",
      },

      // North Carolina Only Fields
      veteranOwned: '',
      disabledVeteranOwned: '',
      netReceiptsUnder1M: '',
      natureOfBusiness: '',

      // INDIANA  Only Fields
      entityStructure: "",
      shareholders: [{
        firstName: "",
        lastName: "",
        profession: "",
        indianaProfessionalLicenseNumber: "",
        country: "",
        address: "",
        address2: "",
        city: "",
        state: "",
        zip: "",
      },
      ],
      providesHealthCareAcceptsReimbursement: "",
      isHealthCareEntity: "",
      ownershipAndControlInterests: [],
      isMedicaidProvider: "",

      // Tennessee Only Fields
      membersWithStake: "",

      isPersonSigningPresident: "",
      isPersonSigningSecretary: "",

      // All States may use some of these fields
      typeOfEntity: annualBusinessType ? annualBusinessType : "",

      informationChange: {
        principalAddress: {
          changed: "",
          newAddress: {
            address: "",
            address2: "",
            city: "",
            state: "",
            // state: forcedStatePrincipal[sitePhrasing.state] ? Object.keys(forcedStatePrincipal[sitePhrasing.state])[0].toUpperCase() : '',
            zip: "",
            county: "",
          },
        },
        mailingAddress: {
          changed: sitePhrasing.state === "Georgia" ? "no" : "",
          newAddress: {
            address: "",
            address2: "",
            city: "",
            state: "",
            zip: "",
            county: "",
          },
        },

        contactNumber: {
          changeNumber: "",
          newContactNumber: "",
        },

        changeOfficers: "",

        registeredAgent: {

          raCapacity: "",
          agentEntityName: "",

          agentChange: sitePhrasing.state === "Mississippi" ? "no" : "",

          agentName: "",
          title: "",

          newAgent: "",
          agentAddressChange: "",

          agentMailingAddressChange: "",
          agentStreetAddressChange: "",

          emailAddressChange: "",
          newEmailAddress: "",

          agentChangeType: "",
          agentType: "",

          firstName: "",
          lastName: "",
          email: "",
          businessName: "",

          newAddress: {
            address: "",
            address2: "",
            city: "",
            state: forcedRegistered[sitePhrasing.state] ? Object.keys(forcedRegistered[sitePhrasing.state])[0].toUpperCase() : "",
            zip: "",
            county: "",
          },

          newStreetAddress: {
            address: "",
            address2: "",
            city: "",
            state: forcedRegistered[sitePhrasing.state] ? Object.keys(forcedRegistered[sitePhrasing.state])[0].toUpperCase() : "",
            zip: "",
            county: "",
          },
        },
        authorizedPerson: {
          authorizedPersonChange: sitePhrasing.state === "Georgia" ? "no" : "",
          removingAgents: "",
          removedAgents: [],
          addingAgents: "",
          addedAgents: [],

          changingAddresses: "",
          changedAddresses: [],

          changingAddress: "",
          changedAddress: {
            address: "",
            address2: "",
            city: "",
            state: "",
            zip: "",
          },
        },

        llcManager: {
          llcManagerChange: "",
          removingAgents: "",
          removedAgents: [],
          addingAgents: "",
          addedAgents: [],

          changingAddresses: "",
          changedAddresses: [],
        },

        officer: {
          officerChange: "",
          removingOfficers: "",
          removedOfficers: [],
          addingOfficers: "",
          addedOfficers: [],

          changingAddresses: "",
          changedAddresses: [],

        },

        director: {
          directorChange: "",
          removingDirectors: "",
          removedDirectors: [],
          addingDirectors: "",
          addedDirectors: [],

          changingAddresses: "",
          changedAddresses: [],
        },

        emailAddress: {
          emailAddressChange: "",
          newEmailAddress: "",
        },

        NAICS: {
          changeCodes: sitePhrasing.state === "Tennessee" ? "yes" : "",
          code1: "",
          code2: "",
          code3: "",
        },
      },

      noPublicRecordExemption: false,
      tellingTruth: false,
      iAmAuthorized: false,
      annualAgree: false,
      informationAccurate: false,

      signersCapacity: "",
      onBehalfOf: "",
      dateSigned: new Date().toISOString().split("T")[0],

      electronicSignature: "",
      title: "",

      phoneNumber: "",
      email: "",

      firstName: "",
      lastName: "",
    },
  };
};

const referenceErrorMessage = sitePhrasing.referenceErrorMessage ? sitePhrasing.referenceErrorMessage : `Reference number must be exactly ${sitePhrasing.referenceLength} characters long.`;
const referenceValidation: any = sitePhrasing.referenceValidation
  ? yup.string().required().matches(sitePhrasing.referenceValidation, referenceErrorMessage)
  : yup.string().required("Required").length(Number(sitePhrasing.referenceLength), referenceErrorMessage);

export const forcedStatePrincipal: any = {
  "North Carolina": {
    nc: true,
    "north carolina": true,
  },
  Georgia: {
    ga: true,
    georgia: true,
  },
  Virginia: {
    va: true,
    virginia: true,
  },
};

export const forcedRegistered: any = {
  Florida: {
    fl: true,
    florida: true,
  },
  Indiana: {
    in: true,
    indiana: true,
  },
  "North Carolina": {
    nc: true,
    "north carolina": true,
  },
  Georgia: {
    ga: true,
    georgia: true,
  },
  Mississippi: {
    ms: true,
    mississippi: true,
  },
  Montana: {
    mt: true,
    montana: true,
  },
  Tennessee: {
    tn: true,
    tennessee: true,
  },
  Virginia: {
    va: true,
    virginia: true,
  }
};

export const isAnnualSelected = (selectedProducts: any) => {
  return selectedProducts["annualReport"] || selectedProducts["annualRegistration"] || selectedProducts["amend"] || selectedProducts["reinstate"] || selectedProducts["initialRegistration"];
}

export const generatePurchaseValidationSchema = (selectedProducts: any, options: {
  validateTerms?: boolean,
}) => {

  const {
    validateTerms = true,
  } = options;

  const annualSelected = isAnnualSelected(selectedProducts);
  const pastDueAnnualSelected = selectedProducts['pastDueAnnualReport']

  let isGeneralPurchase = true;
  if (
    annualSelected ||
    selectedProducts["einTaxId"] ||
    selectedProducts["legalNoticeAdvertisement"] ||
    selectedProducts["fictitiousNameRenewal"] ||
    selectedProducts["boiReport"] ||
    pastDueAnnualSelected
  ) {
    isGeneralPurchase = false;
  }

  return yup.object().shape({

    firstName: yup.string().required("Required"),
    lastName: yup.string().required("Required"),
    email: yup.string().required("Required").email("Please enter a valid email"),
    phoneNumber: yup.string().required().matches(/^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/i, "Invalid phone number"),
    referenceNumber: referenceValidation,
    businessName: yup.string().required("Required"),

    ...(validateTerms ? {
      termAndConditionAgree: yup.bool().required().oneOf([true], "Must be checked"),
    } : {}),

    ...(isGeneralPurchase ? {
      electronicSignature: yup.string().required("Required"),
    } : {}),

    ...(selectedProducts['fictitiousNameRenewal'] ? {
      fictitiousNameRenewal: fictNameRenewalValidationSchema,
    } : {}),

    ...(selectedProducts["legalNoticeAdvertisement"] && !selectedProducts["fictitiousNameRenewal"] ? {
      einTaxInfo: legalNameValidationSchema,
    } : {}),

    ...(selectedProducts["einTaxId"] ? {
      einTaxInfo: einTaxIdValidationSchema(),
    } : {}),

    ...(annualSelected ? {
      annualReport: StateAnnualValidation[sitePhrasing.state]
        ? GenerateStateAnnualValidation(sitePhrasing.state, validateTerms)
        : standardAnnualSchema,
    } : {}),
    ...(pastDueAnnualSelected ? {
      annualReport: StateAnnualPastDueValidation[sitePhrasing.state]
        ? StateAnnualPastDueValidation[sitePhrasing.state]
        : standardAnnualSchema
    } :
      {}),
  })
};

const standardAnnualSchema = yup.object().shape({
  electronicSignature: yup.string().required("Required"),
  title: yup.string().required("Required"),
});
